"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupDetailFormPage = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var semantic_ui_react_1 = require("semantic-ui-react");
var react_router_1 = require("react-router");
var react_router_dom_1 = require("react-router-dom");
var useFirstGetGroups_1 = require("../effects/useFirstGetGroups");
var i18n_1 = __importDefault(require("../i18n"));
var GroupDetailForm_1 = require("./GroupDetailForm");
var useFirstGetGroupUsers_1 = require("../effects/useFirstGetGroupUsers");
var util_1 = require("../util");
var TitleHelmet_1 = require("./TitleHelmet");
exports.GroupDetailFormPage = (0, react_router_1.withRouter)(function (state) {
    var groupId = state.match.params.groupId;
    // eslint-disable-next-line @typescript-eslint/no-shadow
    var group = state.groups.filter(function (group) { return group.id === groupId; })[0];
    var editableLoading = !!groupId && !group;
    var editable = !groupId || (0, util_1.isUserJoinnedInGroup)(group, state.selfUser);
    (0, useFirstGetGroups_1.useFirstGetGroups)(state);
    (0, useFirstGetGroupUsers_1.useFirstGetGroupUsers)(state, groupId);
    return ((0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Dimmer.Dimmable, { dimmed: state.groupsLoading || editableLoading, children: [(0, jsx_runtime_1.jsx)(semantic_ui_react_1.Dimmer, { active: state.groupsLoading || editableLoading, inverted: true, children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Loader, { children: i18n_1.default.loading }) }), (0, jsx_runtime_1.jsx)(TitleHelmet_1.TitleHelmet, { title: group ? group.name : undefined }), (0, jsx_runtime_1.jsx)("p", { children: (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: groupId ? "/groups/".concat(groupId) : "/groups", children: i18n_1.default.back }) }), editable ? ((0, jsx_runtime_1.jsx)(GroupDetailForm_1.GroupDetailForm, { group: group, groupLoading: state.groupsLoading, setGroupsFetchRequest: state.setGroupsFetchRequest })) : ("You cannot edit group because you are not group member.")] }));
});
